module.exports = __webpack_public_path__ + "static/media/puzzle-3-bg.18c28ab2.svg";